// src/utils/logout.ts
import api from "../../features/auth/axiosConfig";
import { NavigateFunction } from "react-router-dom";

export const logout = async (navigate: NavigateFunction) => {
  try {
    await api.get("/pos/logout");
  } catch (error) {
    console.error("Logout failed:", error);
  } finally {
    sessionStorage.clear();
    navigate("/");
  }
};
